import type { IconProps } from './IconProps';

export const HelpIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <g clipPath="url(#clip0_2976_2520)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.31966 4.38033C2.54472 5.38088 2.0835 6.63666 2.0835 8.00016C2.0835 9.36367 2.54472 10.6195 3.31967 11.62L5.1125 9.82718C4.77748 9.29878 4.5835 8.67212 4.5835 8.00016C4.5835 7.32821 4.77747 6.70156 5.11249 6.17316L3.31966 4.38033ZM4.38032 3.31967L6.17314 5.1125C6.70155 4.77748 7.3282 4.5835 8.00016 4.5835C8.67166 4.5835 9.29792 4.77721 9.82609 5.11181L11.619 3.31889C10.6186 2.54441 9.36322 2.0835 8.00016 2.0835C6.63665 2.0835 5.38087 2.54472 4.38032 3.31967ZM12.6799 4.37933L10.8871 6.17207C11.2226 6.7007 11.4168 7.32775 11.4168 8.00016C11.4168 8.67259 11.2226 9.29964 10.8871 9.82827L12.6799 11.621C13.4553 10.6203 13.9168 9.36413 13.9168 8.00016C13.9168 6.63621 13.4553 5.38004 12.6799 4.37933ZM11.619 12.6814L9.82607 10.8885C9.2979 11.2231 8.67165 11.4168 8.00016 11.4168C7.32821 11.4168 6.70156 11.2229 6.17316 10.8878L4.38033 12.6807C5.38088 13.4556 6.63666 13.9168 8.00016 13.9168C9.36321 13.9168 10.6186 13.4559 11.619 12.6814ZM2.7588 13.2475C4.10071 14.5879 5.95364 15.4168 8.00016 15.4168C12.0963 15.4168 15.4168 12.0963 15.4168 8.00016C15.4168 3.90405 12.0963 0.583496 8.00016 0.583496C3.90405 0.583496 0.583496 3.90405 0.583496 8.00016C0.583496 10.0469 1.41258 11.9 2.75322 13.242C2.75407 13.2428 2.75493 13.2437 2.75579 13.2446C2.75679 13.2456 2.75779 13.2466 2.7588 13.2475ZM8.00016 6.0835C6.94162 6.0835 6.0835 6.94162 6.0835 8.00016C6.0835 9.05871 6.94162 9.91683 8.00016 9.91683C9.05871 9.91683 9.91683 9.05871 9.91683 8.00016C9.91683 6.94162 9.05871 6.0835 8.00016 6.0835Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_2976_2520">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
